import { type FC, type ReactNode } from 'react';

import { MuiConfig as GenericMuiConfig } from '@craft/ui/components/config';

import { theme } from './theme';

interface MuiConfigProps {
  readonly children: ReactNode;
}

export const MuiConfig: FC<MuiConfigProps> = ({ children }) => (
  <GenericMuiConfig theme={theme}>{children}</GenericMuiConfig>
);
